import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { filter, map, startWith } from 'rxjs/operators';
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';

/** @deprecated - This component should not be used */
@Component({
    selector: 'sb-modal-header',
    template: `
        <header class="sb-modal-header" *ngIf="data$ | async as data">
            <div *ngIf="data.title">
                <h3>{{ data?.title }}</h3>
            </div>
            <ng-content *ngIf="!data.title"></ng-content>
            <a class="close" [routerLink]="closeUrl" replaceUrl="true"></a>
        </header>
    `,
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, RouterLink],
    standalone: true
})
export class SbModalHeaderComponent {
    get dialog(): boolean {
        return this._dialog;
    }

    @Input() set dialog(value: boolean) {
        this._dialog = value;
        this.closeUrl =
            this.dialog === true
                ? ['', { outlets: { dialog: null } }]
                : ['', { outlets: { dialog: null, modal: null } }];
    }
    constructor(private router: Router, private route: ActivatedRoute) {}
    private _dialog: boolean;
    closeUrl: Array<any> = ['', { outlets: { dialog: null } }];
    data$ = this.router.events.pipe(
        filter((event) => event instanceof NavigationEnd),
        map((_) => this.route.snapshot?.data),
        startWith(this.route.snapshot?.data)
    );
}
